import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Result } from 'antd';
import { LockOutlined } from '@ant-design/icons';
import { LoadingSpinner } from '../../../components/common/LoadingSpinner.jsx';
import { ErrorState } from '../../../components/common/ErrorState.jsx';
import { useToolAccess } from '../hooks/useToolAccess.js';
import { useToolPurchaseOptions } from './ToolPurchase.jsx';

/**
 * Bọc trang công cụ: công cụ thu phí mà người xem chưa có gói thì hiện màn hình mua gói thay cho trang.
 * Danh sách công cụ thu phí do back-end quyết định (constants/tool-access.constant.js); công cụ miễn phí hiện ngay như cũ.
 * Mua gói ở đây sẽ chuyển sang /checkout/:planId?returnTo=<trang công cụ>, thanh toán xong tự quay lại công cụ.
 * `preview`: chưa mua vẫn vào được trang để xem thử với số liệu mẫu; trang tự mở modal mua khi khách làm chi tiết
 * (ToolPurchaseModal — đang dùng cho công cụ lương thưởng và chương trình bán hàng).
 */
export function ToolAccessGuard({ slug, preview = false, children }) {
  const { access, loading, error, reload } = useToolAccess();

  if (loading && !access) {
    return <LoadingSpinner tip="Đang kiểm tra quyền dùng công cụ..." minHeight="60vh" />;
  }
  if (error && !access) {
    return <ErrorState title="Không kiểm tra được quyền dùng công cụ" subTitle={error} onRetry={reload} />;
  }

  const tool = access?.[slug];
  // Công cụ có phần dùng thử (SOP: 3 quy trình đầu) tự khóa phần còn lại bên trong trang
  if (preview || !tool || tool.hasAccess || tool.freeCodes?.length) return children;
  return <ToolPaywall plans={tool.requiredPlans || []} />;
}

function ToolPaywall({ plans }) {
  const navigate = useNavigate();
  const { subTitle, actions } = useToolPurchaseOptions(plans);

  return (
    <div className="main-container" style={{ minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Result
        icon={<LockOutlined style={{ color: '#f59e0b' }} />}
        title="Công cụ trả phí"
        subTitle={subTitle}
        extra={
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, justifyContent: 'center' }}>
            {actions}
            <Button key="back" onClick={() => navigate('/tools')}>
              Về danh sách công cụ
            </Button>
          </div>
        }
      />
    </div>
  );
}
